module.exports = __webpack_public_path__ + "img/fiorimpopoli1.d024ec92.jpeg";